import './SaveTheDate.css';

export function SaveTheDate() {
    return (
        <div id="sectionSave the Date" class="video-vertical-container">
            <iframe
                src="https://player.cloudinary.com/embed/?cloud_name=v1xvlgw6&public_id=SaveTheDateFinal"
                allow="fullscreen; encrypted-media; picture-in-picture"
                allowfullscreen
                frameborder="0"
            ></iframe>
        </div>
    )
}